import { NavLink } from "react-router-dom";
import { Activity, ChevronsLeft, ChevronsRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/lib/auth";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { NAV_SECTIONS, canAccess } from "@/lib/permissions";

export const Sidebar = ({ collapsed, onToggle }) => {
  const features = useQuery({ queryKey: ["features"], queryFn: () => get("/me/features"), staleTime: 60000 });
  const { user } = useAuth();
  return (
    <aside data-testid="sidebar" className={cn("flex flex-col h-full bg-slate-950 border-r border-border shrink-0 transition-[width] duration-200", collapsed ? "w-60 lg:w-14" : "w-60")}>
      <div className="h-12 flex items-center gap-2 px-3 border-b border-border">
        <div className="h-7 w-7 bg-primary rounded-sm flex items-center justify-center shrink-0"><Activity className="h-4 w-4 text-primary-foreground" /></div>
        <div className={cn("leading-tight", collapsed && "lg:hidden")}><div className="font-bold text-sm tracking-tight">ProdTrack</div><div className="eyebrow">MES · Suivi TRS</div></div>
      </div>
      <nav className="flex-1 overflow-y-auto py-2">
        {NAV_SECTIONS.map((s) => {
          const items = s.items.filter((i) => canAccess(user.role, i.roles)
            && (!i.module || features.data?.modules?.[i.module]?.actif));
          if (!items.length) return null;
          return (
            <div key={s.title} className="mb-2">
              <div className={cn("eyebrow px-3 py-1.5", collapsed && "lg:hidden")}>{s.title}</div>
              {items.map((i) => (
                <NavLink key={i.to} to={i.to} end={i.to === "/admin"} title={i.label} data-testid={`nav-${i.to.replace(/\//g, "-").slice(1)}`}
                  className={({ isActive }) => cn("relative flex items-center gap-2.5 mx-1.5 px-2 h-8 rounded-sm text-xs font-medium transition-colors",
                    isActive ? "bg-accent text-foreground" : "text-muted-foreground hover:bg-muted hover:text-foreground")}>
                  {({ isActive }) => (<>
                    {isActive && <span className="absolute left-0 top-1.5 bottom-1.5 w-0.5 bg-primary rounded-sm" />}
                    <i.icon className="h-4 w-4 shrink-0" />
                    <span className={cn("truncate", collapsed && "lg:hidden")}>{i.label}</span>
                  </>)}
                </NavLink>
              ))}
            </div>
          );
        })}
      </nav>
      <button onClick={onToggle} data-testid="sidebar-toggle" className="hidden lg:flex h-9 border-t border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted transition-colors">
        {collapsed ? <ChevronsRight className="h-4 w-4" /> : <ChevronsLeft className="h-4 w-4" />}
      </button>
    </aside>
  );
};
